module.exports = __webpack_public_path__ + "videos/mts-main-products-webinars.9c92420.webm";